const Style = {

  loading: 'opacity-50'

}

export default Style;